module.exports = __webpack_public_path__ + "static/img/logo.7a65ac87.png";